import React from 'react';
import PropTypes from 'prop-types';

export const SimplePayment = ({ width, height, ...props }) => (
  <svg
    data-icon='simple-payment'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M3 22V2l1.5 1.5L6 2l1.5 1.5L9 2l1.5 1.5L12 2l1.5 1.5L15 2l1.5 1.5L18 2l1.5 1.5L21 2v20l-1.5-1.5L18 22l-1.5-1.5L15 22l-1.5-1.5L12 22l-1.5-1.5L9 22l-1.5-1.5L6 22l-1.5-1.5L3 22Zm3-5h12v-2H6v2Zm0-4h12v-2H6v2Zm0-4h12V7H6v2ZM5 19.1h14V4.9H5v14.2Z'
    />
  </svg>
);

SimplePayment.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

SimplePayment.defaultProps = {
  width: 24,
  height: 24,
};
